import VendorPerformanceHeaderFilter from './VendorPerformanceHeaderFilter';
import dayjs from 'dayjs';
import { dateFormat, exportToExcel } from '../../../lib/utils';
import { useSearchParams } from 'react-router-dom';
import VendorPerformanceTable from './VendorPerformanceTable';
import { useFetchData } from '../../../hooks';
import { VendorPerformance } from '../../../types';

const VendorPerformancePage = () => {
  const api = '/reports/vendor-performance';
  const [searchParams] = useSearchParams();
  const startDate =
    searchParams.get('start') !== undefined &&
    searchParams.get('start') !== null
      ? searchParams.get('start')
      : dayjs().subtract(6, 'month').format(dateFormat);
  const endDate =
    searchParams.get('end') !== undefined && searchParams.get('end') !== null
      ? searchParams.get('end')
      : dayjs().add(2, 'month').format(dateFormat);

  const { data, isLoading } = useFetchData<VendorPerformance[]>(api, {
    vendorId: searchParams.get('vendorId') || '',
    startDate: searchParams.get('start') || '',
    endDate: searchParams.get('end') || '',
  });

  const handleExport = () => {
    if (data !== undefined) {
      const rows = data.map((row) => ({
        Code: row.vendorCode,
        Vendor: row.venderDescription,
        'P.O. Number': row.pono,
        'Order Date': row.orderDate,
        'Required Date': row.requiredDate,
        Status: row.status,
      }));

      exportToExcel({
        fileName: `vendor_performance`,
        headers: [
          'Code',
          'Vendor',
          'P.O. Number',
          'Order Date',
          'Required Date',
          'Status',
        ],
        data: rows,
      });
    }
  };

  return (
    <>
      <div className={'page-wrapper'}>
        <VendorPerformanceHeaderFilter
          startDate={startDate}
          endDate={endDate}
          handleExport={handleExport}
        />
        <VendorPerformanceTable data={data} isLoading={isLoading} />
      </div>
    </>
  );
};
export default VendorPerformancePage;
